import { byId, isAr, message, copyText, saveBlob, trackEvent, formatBytes, showFileAdvisory } from './extra-common.js';

const input = byId('b64-input');
const output = byId('b64-output');
let decodedBlob = null;
function bytesToBase64(bytes) {
  let binary = '';
  const size = 0x8000;
  for (let offset = 0; offset < bytes.length; offset += size) binary += String.fromCharCode(...bytes.subarray(offset, offset + size));
  return btoa(binary);
}
byId('b64-run').addEventListener('click', async () => {
  trackEvent('tool_started', 'base64-converter');
  try {
    decodedBlob = null;
    byId('b64-download').hidden = true;
    if (byId('b64-file').files[0] && byId('b64-mode').value === 'encode') {
      const file = byId('b64-file').files[0];
      output.value = `data:${file.type || 'application/octet-stream'};base64,${bytesToBase64(new Uint8Array(await file.arrayBuffer()))}`;
    } else if (byId('b64-mode').value === 'encode') {
      output.value = bytesToBase64(new TextEncoder().encode(input.value));
    } else {
      const match = input.value.trim().match(/^(?:data:([^;,]+);base64,)?([\s\S]+)$/);
      let cleanB64 = match[2].replace(/\s/g, '').replace(/-/g, '+').replace(/_/g, '/');
      while (cleanB64.length % 4 !== 0) cleanB64 += '=';
      const binary = atob(cleanB64);
      const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
      try {
        output.value = new TextDecoder('utf-8', { fatal: true }).decode(bytes);
      } catch {
        decodedBlob = new Blob([bytes], { type: match[1] || 'application/octet-stream' });
        output.value = isAr ? `تم فك ${bytes.byteLength.toLocaleString('ar')} بايت كملف ثنائي.` : `Decoded ${bytes.byteLength.toLocaleString()} bytes as a binary file.`;
        byId('b64-download').hidden = false;
      }
    }
    byId('b64-copy').disabled = false;
    message('b64-status', isAr ? 'اكتملت العملية.' : 'Conversion complete.', 'success');
    trackEvent('tool_completed', 'base64-converter');
  } catch (error) {
    output.value = '';
    byId('b64-copy').disabled = true;
    message('b64-status', error.message || (isAr ? 'تعذر قراءة Base64.' : 'Unable to decode Base64.'), 'error');
    trackEvent('tool_failed', 'base64-converter');
  }
});
byId('b64-file').addEventListener('change', () => {
  const file = byId('b64-file').files[0];
  if (file) {
    input.value = '';
    message('b64-status', `${file.name} · ${formatBytes(file.size)}`);
    if (file.size >= 15 * 1024 * 1024) {
      showFileAdvisory(
        byId('base64-converter-app'),
        isAr
          ? `ملف كبير (${formatBytes(file.size)}) — يجري تشفير/فك Base64 محلياً داخل ذاكرة متصفحك.`
          : `Large file (${formatBytes(file.size)}) — processing locally in device memory.`
      );
    } else {
      showFileAdvisory(byId('base64-converter-app'), '', false);
    }
  }
});
byId('b64-mode').addEventListener('change', () => { byId('b64-file').disabled = byId('b64-mode').value !== 'encode'; });
byId('b64-copy').addEventListener('click', async () => { try { await copyText(output.value); message('b64-status', isAr ? 'تم النسخ.' : 'Copied.', 'success'); } catch { message('b64-status', isAr ? 'تعذر النسخ.' : 'Copy failed.', 'error'); } });
byId('b64-download').addEventListener('click', () => { if (decodedBlob) saveBlob(decodedBlob, 'decoded-file.bin'); });
